export const imgGrid = {
  init() {
    $(document).on('click', '.js-imgGrid .js-lgie', e => {
      const $titleClone = $(e.currentTarget).find('.lgie-title').clone();

      $titleClone.find('span').remove();
      Tracking.dataLayerPush({
        clickCode: 'clickOnCPExperience',
        gaCategory: PAGE_SCRIPTS.page_template,
        gaAction: 'CP Experience',
        gaLabel: $titleClone.text().trim()
      });
    });
  }
};